import { inject, Injectable, Pipe, PipeTransform } from '@angular/core'
import { BusinessNameService } from '@core/services/business.service'

@Injectable({
  providedIn: 'root',
})
@Pipe({
  name: 'businessNameIndicators',
})
export class BusinessNamePipe implements PipeTransform {
  private readonly _businessNameService = inject(BusinessNameService)

  transform(value: string): string {
    if (value === null) {
      return 'Nothing to transform'
    }

    value = this._businessNameService.getReadableIndicatorsName(value)
    return value
  }
}
